import type { OnChangeFn } from "@dresscode-frontend/utility-types";
import { useCallback } from "react";

import Icon from "@/components/Icon/Icon";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";
import { defaultNS, useTranslation } from "@/lib/i18n";

type Props = {
  value?: boolean;
  onChange: OnChangeFn<boolean | undefined>;
};

export function ErrorDeviceToggle({ value, onChange }: Props) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "domain.device.components.deviceFilters.error",
  });

  const handleClick = useCallback(() => {
    onChange(value ? undefined : true);
  }, [value, onChange]);

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleClick}
      className={cn(
        "gap-1.5 transition-colors",
        value &&
          "bg-primary-fill text-primary-on-fill hover:bg-primary-fill-hovered border-primary-fill",
      )}
    >
      <Icon iconName="TriangleAlertIcon" className="h-4 w-4" />
      {t("label")}
    </Button>
  );
}
